import React, {ReactElement} from "react";
import {Dialog} from "@headlessui/react";
import {FormattedMessage} from "react-intl";
import {useAppDispatch, useAppSelector} from "lib/redux/hooks";
import {ReactComponent as CloseIcon} from "components/Icons/close.svg";
import {SecondaryButton} from "components/UIComponents/SecondaryButton";
import {PrimaryButton} from "components/UIComponents/PrimaryButton";
import {menuEditorActions, menuEditorSelectors} from "./editorSlice";
import {menuEditorActions as menuEditorPageActions} from "../menu/menuEditorPageSlice";
import { MenuDocument } from "./MenuDocumentModel";
import { To, useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { authSelectors } from "features/auth/authSlice";
import { menuManagementSelectors } from "features/menu/menumanagement/menuManagementSlice";

export interface ConfirmSaveModalProps {
    backUrl: To
}



export function ConfirmSaveModal(props: ConfirmSaveModalProps): ReactElement {
    const navigate = useNavigate();

    const active = useAppSelector(menuEditorSelectors.confirmSavePopoverActive);
    const document = useAppSelector(menuEditorSelectors.document);

    const dispatch = useAppDispatch();
    const closeModal = () => dispatch(menuEditorActions.setConfirmSavePopover(false));
    

    const menuId = useParams()['menuId'];
    const userId = useAppSelector(authSelectors.customer);
    const menuName = useAppSelector(menuManagementSelectors.menuName(userId, menuId));
    const saveDocument = (document: MenuDocument) => {
        if (userId == null || menuId == null || menuName == null) {
            dispatch(menuEditorPageActions.setError(`incomplete file info, userId: ${userId}, menuId: ${menuId}, menuName: ${menuName}`));
            return;
        }

        return dispatch(menuEditorPageActions.saveDocument({
            userId: userId,
            fileId: menuId,
            name: menuName,
            document: document
        })).then(() => {
            navigate(props.backUrl);
        });
    };
    const doNotSaveDocument = () => {
        closeModal();
        navigate(props.backUrl);
    }
    const saveDocumentReal = () => {
        closeModal();
        document != null && saveDocument(document);
    };

    return (
        <Dialog
            open={active}
            onClose={closeModal}
            className="fixed z-modal inset-0 overflow-y-auto"
        >
            <div className="flex items-center justify-center min-h-screen">
                <Dialog.Overlay className="fixed inset-0 bg-text opacity-60"/>

                <div className="relative flex flex-col w-1/3 max-w-sm mx-auto
                                py-6 px-5 bg-white rounded-lg">

                    <div className="flex-none flex items-center">
                        <Dialog.Title className="flex-auto font-barlow text-lg font-semibold">
                            <FormattedMessage id="editor.confirmsave.title"/>
                        </Dialog.Title>
                        <button className="flex-none"
                                onClick={closeModal}>
                            <CloseIcon className="inline-block w-5 h-5" />
                        </button>
                    </div>

                    <div className="flex-auto flex flex-col">
                        <div className="flex-auto pt-5 pb-10">
                            <p><FormattedMessage id="editor.confirmsave.text" /></p>
                        </div>


                        <div className="flex-none flex gap-2 justify-end items-center">
                            <SecondaryButton onClick={doNotSaveDocument}>
                                <FormattedMessage id="editor.confirmsave.cancel" />
                            </SecondaryButton>
                        
                            <PrimaryButton onClick={saveDocumentReal}>
                                <FormattedMessage id="editor.confirmsave.save" />
                            </PrimaryButton>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}